import { initializeEditorFromTextarea } from "lib/ace-editor";

document.callOnReady(function () {
  $("textarea.ace-editor").each(function () {
    initializeEditorFromTextarea($(this));
  });
});
